<template>
  <div id="shared-fields-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">Select fields to share</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div
              v-for="field in fieldsToShare"
              class="col-md-3"
              :key="field.name"
            >
              <div class="share-field-label">{{ field.description }}</div>
              <label class="mt-checkbox mt-checkbox-outline" :id="'hide-' + field.name">
                Share field
                <input :name="field.name"
                       type="checkbox"
                       :value="true"
                       v-model="field.isShared"
                       @input="field.sharedReadOnly = false"
                />
                <!-- XXX: this span is required for custom checkbox to display icon -->
                <span></span>
              </label><br>
              <label class="mt-checkbox mt-checkbox-outline" :id="'hide-' + field.name">
                Share as read-only
                <input :name="field.name"
                       type="checkbox"
                       :value="true"
                       :disabled="!field.isShared"
                       v-model="field.sharedReadOnly"
                />
                <!-- XXX: this span is required for custom checkbox to display icon -->
                <span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn green pull-left" @click.prevent="shareAll()">Share all</button>
          <button class="btn green pull-left" @click.prevent="shareAll(true)">Share all as read-only</button>
          <button class="btn green" @click.prevent="save" data-dismiss="modal">Save</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pick } from 'lodash';

const FIELDS_TO_SHARE = ['address', 'checkbox', 'checkbox-group',  'currency', 'date', 'select', 'signature',
  'file', 'image-upload', 'textarea', 'number', 'radio-group', 'rating', 'text', 'time', 'phone', 'ssn'];

export default {
  props: {
    fieldList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fieldsToShare: [],
    }
  },
  mounted: function() {
    $('#shared-fields-modal').on('show.bs.modal', () => {
      // filter fields that can be shared and copy only required properties to avoid mutating parent prop
      this.fieldsToShare = this.fieldList
        .filter(f => FIELDS_TO_SHARE.includes(f.type))
        .map(f => pick(f, ['name', 'description', 'isShared', 'sharedReadOnly']))
    });
  },
  methods: {
    save() {
      this.$emit('share', this.fieldsToShare);
    },
    shareAll(readonly) {
      // we need to clear sharing if all fields are already shared
      const shouldShare = !this.fieldsToShare.every(f => f.isShared)

      this.fieldsToShare.forEach(f => {
        this.$set(f, 'isShared', shouldShare);
        if (!shouldShare) {
          this.$set(f, 'sharedReadOnly', false);
        } else if (readonly) {
          this.$set(f, 'sharedReadOnly', shouldShare);
        }
      })
    },
  }
}
</script>


<style scoped lang="scss">
.share-field-label {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// ShareFieldsModal.vue?6ae7ca87